import {
  AsyncPipe,
  NgClass,
  NgFor,
  NgIf,
  NgSwitch,
  NgSwitchCase,
  NgSwitchDefault,
} from '@angular/common';
import { Component, Input } from '@angular/core';
import { CmsArea } from '@domgen/dgx-fe-cms';
import { PromotionalBannerComponent } from '@domgen/dgx-fe-components/banner';
import {
  ButtonComponent,
  ButtonTextComponent,
} from '@domgen/dgx-fe-components/button';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { ThemeDirective } from '@domgen/dgx-fe-components/decoration';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { LoadingOverlayComponent } from '@domgen/dgx-fe-components/loading';
import { PanelComponent } from '@domgen/dgx-fe-components/panel';
import { GAClickDirective, GAPage } from '@domgen/dgx-fe-ga';
import {
  CurrencyFormatPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import { EditableArea } from '@magnolia/angular-editor';
import {
  QuoteOfferPriceDiscountedPipe,
  RegisteredItemMonthlyOrAnnuallyLabelPipe,
} from '@us-registration/data-access';
import { RegistrationWarrantyNotePanelComponent } from '@us-registration/feature-components';
import { RegistrationTermsAndConditionsComponent } from '@us-registration/ui-components';
import { PrepaySubscriptionVariant } from '@us-registration/util-models';
import { ProtectionBenefitsAccordionComponent } from '../../components/protection-benefits-accordion/protection-benefits-accordion.component';
import { ProtectionDetailsAccordionPanelComponent } from '../../components/protection-details-accordion-panel/protection-details-accordion-panel.component';
import { ProtectionDetailsPurchasePriceOptionComponent } from '../../components/protection-details-purchase-price-option/protection-details-purchase-price-option.component';
import { ProtectionDetailsQuoteOfferComponent } from '../../components/protection-details-quote-offer/protection-details-quote-offer.component';
import { translation } from '../../i18n/translation.constant';
import { ProtectionDetailsComponentService } from '../../services/protection-details/protection-details-component.service';

@Component({
  templateUrl: './protection-details.component.html',
  styleUrls: ['./protection-details.component.scss'],
  providers: [
    ProtectionDetailsComponentService,
    provideTranslationDictionaryMapping(translation),
  ],
  standalone: true,
  imports: [
    AsyncPipe,
    ButtonComponent,
    ButtonTextComponent,
    CurrencyFormatPipe,
    EditableArea,
    GAClickDirective,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    LoadingOverlayComponent,
    NgClass,
    NgFor,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    PanelComponent,
    PromotionalBannerComponent,
    ProtectionBenefitsAccordionComponent,
    ProtectionDetailsAccordionPanelComponent,
    ProtectionDetailsPurchasePriceOptionComponent,
    ProtectionDetailsQuoteOfferComponent,
    ProtectionDetailsQuoteOfferComponent,
    QuoteOfferPriceDiscountedPipe,
    RegisteredItemMonthlyOrAnnuallyLabelPipe,
    RegistrationTermsAndConditionsComponent,
    RegistrationWarrantyNotePanelComponent,
    RichTextComponent,
    ThemeDirective,
    TranslatePipe,
  ],
})
@GAPage()
export class ProtectionDetailsComponent {
  @Input() main!: CmsArea;

  readonly prepaySubscriptionVariant: typeof PrepaySubscriptionVariant =
    PrepaySubscriptionVariant;

  constructor(readonly cs: ProtectionDetailsComponentService) {}
}
